import React from "react";
import { TextField, MenuItem } from "@mui/material";

const InputField = ({
  label,
  type = "text",
  margin = "normal",
  fullWidth = true,
  icon,
  multiline = false,
  sx = {},
  rows,
  select = false,
  options = [],
  ...props
}) => {
  return (
    <TextField
    //   label={label}
      type={type}
      placeholder={label}
      fullWidth={fullWidth}
      multiline={multiline}
      rows={rows}
      margin={margin}
      variant="outlined"
      select={select}
      InputLabelProps={{
        sx: {
          fontSize: "14px",
        },
      }}
      InputProps={{
        sx: {
          fontSize: "14px",
        },
        endAdornment: icon ? icon : null,
      }}
      sx={{
        "& .MuiInputLabel-outlined": {
          color: "rgba(120, 119, 119, 1) !important",
          fontSize: "16px",
          fontWeight: 400,
        },
        "& .MuiOutlinedInput-root": {
          borderRadius: "15px",
          height: "60px",
          backgroundColor: "#F5F5F5",
          color: "rgba(120, 119, 119, 1) !important",
          fontSize: "16px",
          fontWeight: 400,
          border: "none",
          "& fieldset": {
            border: "none",
          },
          "&:hover": {
            backgroundColor: "#F0F0F0",
            "& fieldset": {
              border: "none",
            },
          },
          "&.Mui-focused": {
            backgroundColor: "#EEEEEE",
            "& fieldset": {
              border: "none",
            },
          },
          "& input": {
            padding: "18px 20px",
            "&::placeholder": {
              color: "rgba(120, 119, 119, 1)",
              fontSize: "16px",
              fontWeight: 400,
            },
          },
        },
        "& .MuiInputLabel-shrink": {
          transform: "translate(20px, -9px) scale(0.75)",
          backgroundColor: "#F5F5F5",
          padding: "0 8px",
          color: "rgba(120, 119, 119, 1) !important",
        },
        ...sx,
      }}
      {...props}
      error={props.error}
      helperText={props.helperText}
    >
      {select && options && options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default InputField;